import React, {useState, useEffect} from 'react';

import {CadastroSimples, TipoInformacao} from '../../data/interfaces';
import {getListaBanner} from '../../services/firebase';
import {Container, Slider, Noticias} from './styles';

export default function Noticia() {
  const [itens, setItens] = useState<CadastroSimples[]>([]);

  useEffect(() => {
    getListaBanner(TipoInformacao.BANNER, (banners: CadastroSimples[]) => {
      setItens(banners);
      startSilider();
    });
  }, []);

  function startSilider() {
    let curretImageIndex = 0;
    const imagesTmp = document.querySelectorAll<HTMLHeadingElement>(
      'div #slider p',
    );
    const max = imagesTmp === undefined ? 0 : imagesTmp.length;
    setInterval(() => {
      if (max > 0) {
        imagesTmp[curretImageIndex].style.opacity = '0';
        curretImageIndex += 1;
        if (curretImageIndex >= max) {
          curretImageIndex = 0;
        }
        imagesTmp[curretImageIndex].style.opacity = '1';
      }
    }, 5000);
  }

  return (
    <Container>
      <Slider id="slider">
        {itens.map((item) => {
          if (item.noticia) {
            return <Noticias key={item.key}>{item.noticia}</Noticias>;
          }
        })}
      </Slider>
    </Container>
  );

  // return (
  //   <Carousel
  //     id="slider"
  //     activeIndex={index}
  //     indicators={false}
  //     controls={false} interval={7000}
  //   >
  //     {itens.map((item) => {
  //       if (item.noticia) {
  //         return (
  //           <Carousel.Item key={item.key}>
  //             <ContainerNoticia>
  //               <Noticias>{item.noticia}</Noticias>
  //             </ContainerNoticia>
  //           </Carousel.Item>
  //         );
  //       }
  //     })}
  //   </Carousel>
  // );
}
